import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "icon", "theme", "placement", "mouseThrough"];
import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ConfigConsumer from '../ConfigConsumer';
import Icon from '../Icon';
import Tooltip from '../Tooltip';
export default function Annotation(_ref) {
  var children = _ref.children,
      className = _ref.className,
      icon = _ref.icon,
      theme = _ref.theme,
      placement = _ref.placement,
      mouseThrough = _ref.mouseThrough,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    annotationIcon: icon,
    annotationTheme: theme,
    annotationPlacement: placement
  }, function (_ref2) {
    var _ref2$annotationIcon = _ref2.annotationIcon,
        annotationIcon = _ref2$annotationIcon === void 0 ? 'jmti-question-circle' : _ref2$annotationIcon,
        _ref2$annotationTheme = _ref2.annotationTheme,
        annotationTheme = _ref2$annotationTheme === void 0 ? 'dark' : _ref2$annotationTheme,
        _ref2$annotationPlace = _ref2.annotationPlacement,
        annotationPlacement = _ref2$annotationPlace === void 0 ? 'right' : _ref2$annotationPlace;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: children,
      theme: annotationTheme,
      placement: annotationPlacement,
      mouseThrough: mouseThrough,
      arrowPointAtCenter: true
    }, /*#__PURE__*/React.createElement(Icon, _extends({
      className: classNames('jmtd-annotation', annotationIcon, className)
    }, props)));
  });
}
Annotation.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.string,
  theme: PropTypes.string,
  placement: PropTypes.string,
  mouseThrough: PropTypes.bool
};
Annotation.defaultProps = {
  children: null,
  className: '',
  icon: null,
  theme: null,
  placement: null,
  mouseThrough: false
};